/**
 * Devuelve una copia del objeto.
 * Se hace una copia completa y recursiva. (es decir copia los objetos dentro de objetos y array ...)
 * Solo copia los valores, No copia los prototypes ...
 *
 * > NOTA IMPORTANTE.
 * > Hay muchas tecnicas para clonear objetos en javascript.
 * > Para clonear objeto sin profundidad, usar:
 * >  - const newObj = Object.assign({}, obj)
 * >  - const newObj = { ...obj }
 * >
 * > Para clonear objetos con profundidad, usar:
 * >  - const newObj = JSON.parse(JSON.stringify(obj));
 * >  - const newObj = clone(obj);
 *
 * @param {object} - el objeto que queremos duplicar
 * @return {object} un nuevo objeto con los mismos valores
 */

export function clone(o) {
  if (typeof o !== 'object' || o === null) {
    return o;
  } // Nota: typeof null === 'object'

  if (Array.isArray(o)) {
    return o.reduce((acc, cur) => [...acc, clone(cur)], []);
  }

  if (o instanceof Date) {
    return new Date(o.toISOString());
  }

  return Object.keys(o).reduce((acc, cur) => {
    acc[cur] = clone(o[cur]);
    return acc;
  }, {});
}
